import { BUILD_YOUR_ODDS, COUPONS, DAILY_LIST } from '../../../generateBreadcrumb/constants';

export const arrayNavigationFootball = [
    {
        type: DAILY_LIST,
        lng: 'es-es',
        nav: [
            {
                name: 'Cupones',
                page: 'cupones',
            },
            {
                name: 'Torneos',
                page: 'competiciónes',
            },
            {
                name: 'Crear #MiApuesta',
                page: 'byo-hub',
            },
        ],
    },
    {
        type: DAILY_LIST,
        lng: 'it-it',
        nav: [
            {
                name: 'Calcio',
                page: '',
            },
            {
                name: 'Coupons',
                page: 'coupons',
            },
            {
                name: 'Competizioni',
                page: 'competitions',
            },
        ],
    },
    {
        type: COUPONS,
        lng: 'it-it',
        nav: [
            {
                name: 'Calendario',
                page: 'matches',
            },
            {
                name: 'Competizioni',
                page: 'competitions',
            },
        ],
    },
    {
        type: BUILD_YOUR_ODDS,
        lng: 'es-es',
        nav: [
            {
                name: 'Lista Diaria',
                page: 'partidos',
            },
            {
                name: 'Cupones',
                page: 'cupones',
            },
            {
                name: 'Torneos',
                page: 'competiciónes',
            },
        ],
    },
];
